module.exports = __webpack_public_path__ + "img/project14_3.png.bcd9e2b1.webp";